<ng-container *ngFor="let day of dayPrices">
  <div class="font-sm delivery-day-info" *ngIf="day.isActive">
    <div class="d-flex flex-nowrap">
      <div class="fw-bold day-col">
        {{ day.type | cDayNameByType }}
      </div>

      <div>
        <div class="ps-4" *ngFor="let range of day.ranges; let last = last" [class.mb-05]="!last">
          {{ range.start | stringifyMinutes : 'HH:mm' }}
          -
          {{ (range.end) | stringifyMinutes : 'HH:mm' }}

          <strong class="ps-3" *ngIf="overwritingDelivery">
            {{ (overwritingDelivery.price || 0) | currencyFormat: currencySymbol }}
          </strong>

          <strong class="ps-3" *ngIf="!overwritingDelivery">
            {{ range.price | currencyFormat: currencySymbol }}
          </strong>
        </div>
      </div>
    </div>
  </div>

  <!--  <div class="font-sm delivery-day-info" *ngIf="!day.isActive">-->
  <!--    <div class="d-flex flex-nowrap">-->
  <!--      <div class="fw-bold day-col">-->
  <!--        {{ day.type | cDayNameByType }}-->
  <!--      </div>-->

  <!--      <div class="ps-4">{{ 'common.dayOff' | translate }}</div>-->
  <!--    </div>-->
  <!--  </div>-->
</ng-container>
